<app-table-toolbar
    [placeholder]="'Search Name or Email Address'"
    [disableEnterSearch]="true"
    [buttons]="toolbarButtons()"
    (actionClick)="onToolbarAction($event)"
    (searchValueChange)="onSearchValueChange($event)" />
